module.exports = __webpack_public_path__ + "img/sample-report-15@3x.a8ea82c2.png";